/**
 * @ngdoc service
 * @name app.weatherCurrentService
 * @description
 * # WeatherCurrentService
 * Service to talk with backend api.
 * @requires app.apiService
**/

/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * photosService
\*---------------------------------------------------------*/
/* @ngInject */
function weatherCurrentService(apiService) {
  /**
   * @ngdoc
   * @name app.weatherCurrentService#getWeatherSubMenu
   * @methodOf app.weatherCurrentService
   * @example
   * ``` js
   * weatherCurrentService.getWeatherSubMenu('LI')
   * ```
   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
   * 'New Jersey' => 'NJ', max of three characters.
   * @description
   * Service to talk with backend api. It calls the apiService.wrap function,
   * passing a region code.
   * @returns {httpPromise} Promise that will resolve into a string url, or it
   * Will throw an error if region code is not a string or is the incorrect length.
   **/
  this.getWeatherSubMenu = (region) => {
    if (angular.isString(region) && region.length < 3) {
      return apiService.wrap('/api/v1/weather/' + region, {});
      // return apiService.wrap('http://localhost:6080/api/v1/weather/' + region, {});
    }
    return new Error('Invalid Region Code');
  };
}

weatherCurrentService.$inject = [
  'apiService'
];

const api = angular
  .module('weatherCurrentService', [])
  .service('weatherCurrentService', weatherCurrentService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/weatherCurrent.js
 **/